import { IProduct } from "$containers";
import useJStyles from "$hooks/useJStyles";
import { Modal, Table, Text } from "$components";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import useEDBIntegratedOrdersTable from "../../hooks/useIntegratedOrdersTable";

type Props = {
  className?: string;
  integratedOrders: EDBIntegratedOrders;
  handleClickProduct: (product: IProduct) => void;
  setIntegratedOrders: (integratedOrders: EDBIntegratedOrders) => void;
};

function IntegratedOrdersTable({
  className,
  integratedOrders,
  handleClickProduct,
  setIntegratedOrders,
}: Props) {
  const { jclasses } = useJStyles();

  const {
    openConfirmDelete,
    allProductsBySuborder,

    handleCancelDialog,
    handleAllValidateDialog,
    getTheadAllProducts: getThead,
    renderAllProducts: renderProducts,
  } = useEDBIntegratedOrdersTable({
    integratedOrders,
    handleClickProduct,
    setIntegratedOrders,
  });

  return (
    <>
      {allProductsBySuborder?.map((productsBySuborder) => (
        <Table
          key={productsBySuborder.suborderReference}
          bodyData={renderProducts(productsBySuborder.products)}
          rowsPerPage={productsBySuborder.products.length}
          thead={getThead(productsBySuborder)}
          usePaper={false}
          className={className}
        />
      ))}
      <Modal
        title="Confirmation de suppression"
        open={openConfirmDelete}
        onCancel={handleCancelDialog}
        onValidate={handleAllValidateDialog}
      >
        <div className={jclasses.jDialogContent}>
          <Text>Êtes vous sûr de vouloir continuer ?</Text>
        </div>
      </Modal>
    </>
  );
}

export default IntegratedOrdersTable;
